"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const mapScale_1 = require("./mapScale");
const _ = require("lodash");
exports.MapScaleSelector = (props) => React.createElement("div", null,
    React.createElement("label", null,
        "Margines: ",
        React.createElement("input", { type: "number", min: 0, max: 100, step: 1, size: 3, maxLength: 3, style: { width: 51 }, title: "mm", value: props.margin, onChange: e => props.onMarginChange(Number(e.target.value)) })),
    Object.keys(mapScale_1.PageHeight).filter(v => _.isNaN(Number(v))).map(pageType => [
        React.createElement("br", null),
        React.createElement("label", null,
            pageType,
            ": 1:",
            React.createElement("input", { type: "number", min: 100, max: 500000, step: 100, value: _.defaultTo(props.getScale(mapScale_1.PageHeight[pageType]), ''), onChange: e => props.onScaleChange(Number(e.target.value), mapScale_1.PageHeight[pageType]) }))
    ]));



//////////////////
// WEBPACK FOOTER
// ./src/map/MapScaleSelector.tsx
// module id = 309
// module chunks = 0